import * as apiContract from '@/api/contract'
import * as _ from 'lodash'
// import * as 

const keyLists = [
  'id',
  'agreement_status',
  'end_classification',
  'name',
  'kana',
  'postnumber',
  'address',
  'address2',
  'address3',
  'address4',
  'no',
  'email',
  'job_type_classification',
  'job_type_name',
  'tel1',
  'tel2',
  'extension',
  'fax',
  'account_number',
  'account_number_max',
  'license_number',
  'license_number_max',
  'note_number',
  'note_number_max',
  'admin_number',
  'admin_number_max',
  'default_payment',
  'webuser_id', // WEB会員ID
  'request_code', // お申込みコード,
  'settlement_type', // 決済方法（1=クレカ、2=口座振替、9=WEB請求書）
  'payment_type' // 支払い方法（1=一括　2=分割）
]

const getDefaultState = () => {
  const defaults = {}
  _.each(keyLists, (key) => {
    defaults[key] = (key === 'default_payment') ? 6 : null
  })

  return defaults
}

const contract = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    isAgreement: state => state.agreement_status === '本契約' || state.agreement_status === '停止解除' || (state.agreement_status === '終了' && state.end_classification === 2)
  },
  mutations: {
    // データをstateに保存
    setAllData(state, payload) {
      const { data } = payload

      _.each(keyLists, (key) => {
        state[key] = typeof data[key] !== 'undefined' ? data[key] : null
      })
    },  
    setSettlementType(state, value) {
      state.settlement_type = value
    },    
    setPaymentType(state, value) {
      state.payment_type = value
    },    
    setWebUserId(state, value) {
      state.webuser_id = value
    },
    setRequestCode(state, value) {
      state.request_code = value
    },    
    // データを初期状態に戻す
    resetData(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    // 契約情報の取得
    async getContractData({ commit }) {
      await apiContract
        .getContract()
        .then(response => {
          const data = response.data
          // if (r && r.data && r.data.status === 200) {
          commit('setAllData', { data })
          // }
        })
    },
    // // 支払い方法の変更
    // async updateDefaultPayment({ state, commit }) {
    //   // 契約情報変更API
    //   const res = await apiContract
    //     .updateContract({ payment_method: state.default_payment })
    //     .then(response => {
    //       const data = response.data
    //       if (data.status === 0) {
    //         return response
    //       } else {
    //         throw res
    //       }
    //     })
    //     .catch(error => {
    //       return Promise.reject(error)
    //     })
    //   return res
    // },
    // 決済方法（1=クレカ、2=口座振替、9=WEB請求書）
    setSettlementType({ commit }, value) {
      commit('setSettlementType', value)
    },
    // 支払い方法（1=一括　2=分割）
    setPaymentType({ commit }, value) {
      commit('setPaymentType', value)
    },
    // setSettlementType
    // WEB会員ID設定
    setWebUserId({ commit }, value) {
      commit('setWebUserId', value)
    },
    // お申込みコード設定
    setRequestCode({ commit }, value) {
      commit('setRequestCode', value)
    }
  }
}

export default contract
